import {
  ifElse,
  propEq,
  prop,
  either,
  always,
  not,
  compose,
  identity,
} from 'ramda'

const TEXT_NODE_TYPE = 3
const SELECTION_TYPE_RANGE = 'Range'

// Gets nodeValue from text node or innerText from other nodes
const getNodeText = ifElse(
  propEq('nodeType', TEXT_NODE_TYPE),
  prop('nodeValue'),
  prop('innerText')
)

// Check that input parameter is not null and obj.type === SELECTION_TYPE_RANGE
export const extractSelectedText = ifElse(
  either(
    compose(
      not,
      identity
    ),
    compose(
      not,
      propEq('type', SELECTION_TYPE_RANGE)
    )
  ),
  always(''),
  extractText
)

// Insert node into cursor position.
// Chrome, Safari OK, TODO: Support FF, Edge
export const insertNodeIntoCursorPosition = (selection, node) => {
  if (!selection) {
    selection = window.getSelection()
  }
  const range = selection.getRangeAt(0)
  range.deleteContents()
  range.insertNode(node)
}

// Select current node
// Chrome, Safari OK, TODO: Support FF, Edge
export const selectNode = (selection, node) => {
  if (!selection) {
    selection = window.getSelection()
  }
  const rangeToSelect = document.createRange()
  rangeToSelect.selectNodeContents(node)
  selection.removeAllRanges()
  selection.addRange(rangeToSelect)
}

function extractText(selection) {
  const {
    endContainer,
    endOffset,
    startContainer,
    startOffset,
  } = selection.getRangeAt(0)

  if (startContainer === endContainer) {
    return getNodeText(startContainer).slice(startOffset, endOffset)
  }

  let currentNode = startContainer
  let text = getNodeText(startContainer).slice(startOffset)

  while (
    currentNode &&
    (currentNode !== endContainer && currentNode !== endContainer.parentNode)
  ) {
    if (startContainer !== currentNode) {
      text += getNodeText(currentNode)
    }
    currentNode = currentNode.nextSibling || currentNode.parentNode.nextSibling
  }

  text += getNodeText(endContainer).slice(0, endOffset)

  return text
}
